import { render, staticRenderFns } from "./OrderGrossTotal.vue?vue&type=template&id=7d7ffdd3&functional=true&"
import script from "./OrderGrossTotal.vue?vue&type=script&lang=js&"
export * from "./OrderGrossTotal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports